import styled from 'styled-components';
import { getColor, makePercent, typeScale, round } from 'core/utils';
import Heading from 'core/components/Heading';
import Button from 'core/ui/Button';
import { Slide } from 'listing/components/Gallery/thumbStyles';

const breakpoints = '(max-width: 767px), (min-width: 992px) and (max-width: 1024px)';

export const Title = styled(Heading)`
	margin: 0 auto 0 0;
	font-weight: 600;
	font-size: 18px;
	line-height: ${round(23/18)};
`;

export const Wrapper = styled.section`
	padding: ${({ isPreview }) => isPreview ? '16px 0' : '0'};
`;

export const Row = styled.div`
	display: flex;
	margin: 0 -24px;
	padding: 20px 0;

	@media ${breakpoints} {
		display: block;
		margin: 0;
	}
`;

export const Col = styled.div`
	padding: 0 24px;
	max-width: ${props => makePercent(props.large ? 5 : 3, 8)};
	flex-basis: ${props => makePercent(props.large ? 5 : 3, 8)};

	@media ${breakpoints} {
		max-width: 100%;
		padding: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
`;

export const AvgContainer = styled.div`
	display: flex;
	align-items: flex-end;
`;

export const AverageRating = styled.h3`
	font-size: 29px;
	line-height: 1;
	letter-spacing: -0.73px;
	color: ${getColor('pelorous')};
	margin: 0;
`;

export const AvgExplain = styled.span`
	display: block;
	font-weight: 600;
	font-size: 15px;
	line-height: 1.25;
	letter-spacing: 0.2px;
	margin-left: ${typeScale(1)};
	color: ${getColor('gray11')};
`;

export const ButtonsRow = styled.div`
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	margin: 0 -8px;
	padding: ${typeScale(4)} 0;
`;

export const ButtonStyled = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 8px 16px 8px;
	padding-top: 1px;
	line-height: 1;
	white-space: nowrap;

	@media ${breakpoints} {
		padding: 0 19px;
		flex: 1;
	}
`;

export const ReadAllBtn = styled.a`
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${getColor("black")};
	text-decoration: underline;
	font-weight: 600;
	margin: 0 8px 16px 8px;

	svg {
		margin-left: ${typeScale(2)};
		transform-origin: center;
		transition: transform 0.2s ease-in-out;
	}

	&:focus, &:active, &:hover {
		text-decoration: underline;

		svg {
			transform: scale(1.3);
		}
	}

	@media ${breakpoints} {
		width: 100%;
	}
`;

export const RatingStarsWrapper = styled.div`
	padding: 6px 0;
`;

export const ImageGalleryWrapper = styled.div`
	padding-top: 16px;

	${Slide} {
		min-width: 200px;
	}
`;

export const ReviewsPhotosHeader = styled.h4`
	font-weight: 600;
	font-size: 19px;
	line-height: 20px;
`;

export const ReviewsLink = styled.a`
	color: inherit;
	display: block;
`;

export const WriteReviewContainer = styled.div`
	margin-top: ${typeScale(2)};
	margin-bottom: ${typeScale(3)};

	@media (min-width: 1024px) {
		margin-top: ${typeScale(3)};
		margin-bottom: 0;
	}

	a, button {
		display: inline-flex;
	}
`;
